import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-default-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class LayoutDefaultHeaderComponent implements OnInit {
  public isCollapsed = true;

  constructor() {}

  ngOnInit() {}
}
